<template>
  <div class="field">
    <label class="label">{{name}}<span v-if="typeof required !== 'undefined'" class="has-text-danger">*</span></label>
    <div class="control">
      <textarea class="textarea" :placeholder="name" :value="modelValue" @input="event => $emit('update:modelValue', event.target.value)" :required="required" :readonly="readonly" :disabled="disabled"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'modelValue', 'required', 'readonly', 'disabled'],
  emits: ['update:modelValue']
}
</script>